import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIBaseModule } from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import {ButtonModule, DataTableModule} from 'primeng/primeng';
import { ProjectOptionTokensComponent } from './components/project-option-tokens/project-option-tokens.component';
import { ProjectOptionTokensService } from './services/project-option-tokens.service';

const publicComponents = [
  ProjectOptionTokensComponent,
];
const declarations = [
  ...publicComponents,
];

const imports = [
  CommonModule,
  UIBaseModule,
  UIFormModule,
  DataTableModule,
  ButtonModule,
];
const exports = [...publicComponents];
const entryComponents = [...publicComponents];
const providers = [ProjectOptionTokensService];

@NgModule({
  declarations,
  entryComponents,
  exports,
  imports,
  providers,
})
export class ProjectOptionTokensModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-option-tokens/project-option-tokens.module.ts